export const heroData = {
  title: "Collect leads 24/7, even outside working hours",
  subtitle: "A chatbot greets late-night visitors, qualifies them, and queues their requests for your team to follow up in the morning.",
};

export const featureData = {
  subhead: "Use this template to launch a 24/7 lead-collection workflow",
  image: "/custom-chatbot-spokes/collect-your-leads-even-when-your-team-is-sleeping/cover.jpg",
  imageAlt: "Collect leads 24/7, even outside working hours",
  bulletsTitle: "The chatbot from this template:",
  bullets: [
    "Greets users and signals that agents are offline",
    "Qualifies visitors against your criteria",
    "Captures the request and contact data, queues for morning follow-up",
  ],
  viewTemplateUrl: "/blog/wp-content/uploads/2022/10/Lead-qualification-outside-office-hours.pdf",
  panelUrl: "/panel/toapp/messages/chat-bot",
};

export const sectionsData = [
    {
      heading: "Don't lose hot prospects who browse at night",
      paragraphs: [
        "Your team needs rest. But hot prospects often browse late at night when nobody is around to respond. A chatbot fills that gap, qualifies the lead, and books the conversation for tomorrow.",
      ],
      image: "/custom-chatbot-spokes/collect-your-leads-even-when-your-team-is-sleeping/img1.png",
      imageAlt: "Late-night chatbot collects lead while team sleeps",
      imagePosition: "right",
    },
];

export const relatedData = [
  {"title": "Lead qualification chatbot", "href": "/custom-chatbot/collect-and-qualify-your-leads/"},
  {"title": "Leave-intent contact capture", "href": "/custom-chatbot/collect-contacts-when-users-try-to-leave-website/"},
  {"title": "Newsletter signup chatbot", "href": "/custom-chatbot/collect-users-emails-by-subscription-to-newsletters/"},
  {"title": "Engagement and qualification", "href": "/custom-chatbot/engage-users-in-conversation-qualify-and-collect-contacts/"},
  {"title": "FAQ automation", "href": "/custom-chatbot/free-your-team-from-answering-the-same-questions/"},
  {"title": "Customer feedback chatbot", "href": "/custom-chatbot/get-feedback-from-your-users/"},
];
